<template>
  <div class="database-title">
    <TypeIcon :type="database" />
    <span class="name">{{ databaseTitle }}</span>
  </div>
</template>

<script lang="ts">
import startCase from "lodash/startCase";
import { computed, defineComponent } from "vue";

import * as inject from "@/components/inject";
import TypeIcon from "@/components/TypeIcon.vue";

export default defineComponent({
  name: "DatabaseTitle",
  components: { TypeIcon },
  props: {
    workspaceId: { type: String, required: true },
    tableId: { type: String, required: true },
  },
  setup(props) {
    const workspaceDatabases = inject.workspaceDatabases();

    const database = computed(() => {
      const ws = workspaceDatabases.value?.[props.workspaceId];
      return ws ? ws[props.tableId] : undefined;
    });

    const databaseTitle = computed(() =>
      database.value?.name ? startCase(database.value.name) : "Database"
    );

    return {
      database,
      databaseTitle,
    };
  },
});
</script>

<style scoped lang="scss">
@use "@/styles/emoji.scss";

.database-title {
  display: flex;
  align-items: center;
  width: 100%;

  .name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
